import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getAccountWithdrawalData } from './common';

const getAccountWithdrawalDataId = (_state: AdminState | ClientState, accountWithdrawalDataId: string) => accountWithdrawalDataId;

export const getAllWithdrawalDataArray = createSelector([getAccountWithdrawalData], (withdrawalData) => {
    return Object.values(withdrawalData)
        .reduce((acc, item): AccountWithdrawalDataRecord[] => {
            const items = Object.values(item);

            return [ ...acc, ...items ];
        }, [] as AccountWithdrawalDataRecord[]);
});

export const getWithdrawalDataById = createSelector(
    [ getAllWithdrawalDataArray, getAccountWithdrawalDataId ],
    (accountWithdrawalData, withdrawalId) => {
        return accountWithdrawalData.find((item) => item.AccountWithdrawalDataId === withdrawalId);
    }
);